module.exports = __webpack_public_path__ + "static/img/bg-pic2.db654ba.png";


//////////////////
// WEBPACK FOOTER
// ./src/components/responsibility/bg-pic2.png
// module id = NHoc
// module chunks = 0